module.exports = __webpack_public_path__ + "static/media/logo-asisa-blue.8a6d4ff5.svg";